import { off, onValue, ref } from 'firebase/database';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useContext, useEffect, useState } from 'react';

export const _realtimeMatchTypes = {
  realtimeResults: 'realtimeResults',
  matchDayResults: 'matchDayResults',
  gsResults: 'gsResults',
}

export function useRealtimeResults({ currentSeason_info }) {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_ts, mainRt } = app_state
  const { latestSeason } = currentSeason_info ?? {}

  const [realtimeResults, setRealtimeResults] = useState({});

  const getMatchPath = (forAll, scoreType, pathViews, latestSeason, match_true, uid) => {
    const path = `clients/${pathViews.clients}/events/${pathViews.events}/sports/${pathViews.sports}/${scoreType}/${latestSeason}/`
    if (forAll) {
      return path
    } else {
      if (uid) {
        return `${path}${match_true?._itemKey}/${uid}`
      } else {
        return `${path}${match_true?._itemKey}`
      }
    }
  }

  useEffect(() => {
    if (!app_ts?.realtime || !latestSeason || !pathViews?.sports) return
    const path_realtime = getMatchPath(true, _realtimeMatchTypes.realtimeResults, pathViews, latestSeason)
    const submissionsRef = ref(app_ts.realtime, path_realtime);
    // Listen for live changes
    const unsubscribe = onValue(submissionsRef, (snapshot) => {
      console.log('⚡realtimeResults ⚡', snapshot.val())
      setRealtimeResults({ realtimeResults: snapshot.val() || {} });
    });
    // Cleanup listener on unmount
    return () => off(submissionsRef);
  }, [pathViews?.sports, latestSeason]);

  return { realtimeResults };
}